import React, { PureComponent } from 'react';
import Fragment from 'react-dot-fragment';
import OneVisualLayout from "../../layouts/one-visual";
import { getRequest } from '../../../../api/ApiService';
import { Loader } from 'react-loaders';
import { Modal } from "react-bootstrap";
import styled from 'styled-components';

import FinancialTargets from '../../components/FinancialTargets';

import MarketShareVideo from '../../../../containers/assets/goals-and-targets-market-share.mp4';
import RevenuesVideo from '../../../../containers/assets/goals-and-targets-revenues.mp4';
import GrossMarginsVideo from '../../../../containers/assets/goals-and-targets-gross-margins.mp4';
import SharePriceVideo from '../../../../containers/assets/goals-and-targets-share-price.mp4';
import RoeVideo from '../../../../containers/assets/goals-and-targets-roe.mp4';
import RoaVideo from '../../../../containers/assets/goals-and-targets-roa.mp4';
import EpsVideo from '../../../../containers/assets/goals-and-targets-eps.mp4';

const videos = {
  'Market Share': MarketShareVideo,
  'Revenues': RevenuesVideo,
  'Gross Margins': GrossMarginsVideo,
  'Share Price': SharePriceVideo,
  'ROE': RoeVideo,
  'ROA': RoaVideo,
  'EPS': EpsVideo,
};

const ModalVideoWrapper = styled.div`
  width: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #3A507B;
  border-radius: 10px;

  &:before {
    display: block;
    content: '';
    align-items: center;
    background: #0006;
    display: flex;
    justify-content: center;
    opacity: 1;
    position: absolute;
    left: 0px;
    right: 0px;
    top: 0px;
    bottom: 0px;
    transition: opacity .3s ease;
    border-radius: 10px;
  }

  &.is-playing:before, &.is-playing button {
    opacity: 0;
  }
  &.is-playing:hover:before, &.is-playing:hover button {
    opacity: 1;
  }
  &:hover video {
    cursor: pointer;
  }
`;

const PlayPauseButton = styled.button`
  align-items: center;
  background: none;
  background: #2a4169;
  border: none;
  border-radius: 50%;
  box-shadow: 0 4px 4px 0 #0000001a;
  color: #fff;
  cursor: pointer;
  display: flex;
  font-size: 2rem;
  height: 80px;
  justify-content: center;
  padding: 0;
  text-align: center;
  width: 80px;
  z-index: 2;
  position: absolute;
  transition: opacity .3s ease;
  opacity: 1;
`;

const CloseModalVideoButton = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 20px;
  color: #fff;
  padding: 0;
  line-height: normal;
`;

class ResultsAreInStep6 extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      financialTargets: [],
      loaded: false,
      isModalShown: false,
      isVideoPlaying: false,
      selectedVideo: null
    };

    this.videoRef = null;
  }

  handlePlayPause = () => {
    if (this.videoRef) {
      if (this.state.isVideoPlaying) {
        this.videoRef.pause();
      } else {
        this.videoRef.play();
      }
      this.setState({ isVideoPlaying: !this.state.isVideoPlaying });
    }
  };

  openModal = (videoSrc) => {
    this.setState({
      isModalShown: true,
      selectedVideo: videoSrc,
    });
  };

  closeModal = () => {
    this.setState({
      isModalShown: false,
      isVideoPlaying: false
    });
  };

  onHelpIconClick = (field) => {
    if (videos[field]) {
      this.openModal(videos[field]);
    }
  };

  componentDidMount() {
    const { activeRound } = this.props;

    getRequest(`${process.env.REACT_APP_API_URL}v2/games/targets/?round_number=${activeRound}`)
      .then(res => {
        let financialTargets = res.body;

        this.setState({
          financialTargets,
          loaded: true,
        });
      })
      .catch(err => { });
  }

  render() {
    const { activeRound } = this.props;
    const { financialTargets, loaded, isModalShown, isVideoPlaying } = this.state;

    return loaded ? (
      <OneVisualLayout
        section="RESULTS ARE IN!"
        title="Financial Goals "
        paragraph1={(
          <Fragment>These were the <b>financial metrics and targets</b> that drove your team score this round.</Fragment>
        )}
        visual={(
          <div>
            <Modal show={isModalShown} onHide={this.closeModal} className="goals-and-targets-modal">
              <Modal.Body>
                <ModalVideoWrapper className={isVideoPlaying ? 'is-playing' : ''}>
                  <video
                    ref={(ref) => { this.videoRef = ref; }}
                    src={this.state.selectedVideo}
                    alt="Welcome Video"
                    onClick={this.handlePlayPause}
                    onEnded={() => this.setState({ isVideoPlaying: false })}
                    style={{ width: '100%', borderRadius: 10 }}
                  />
                  <PlayPauseButton onClick={this.handlePlayPause}>
                    {isVideoPlaying ? '❚❚' : '▶'}
                  </PlayPauseButton>
                  <CloseModalVideoButton>×</CloseModalVideoButton>
                </ModalVideoWrapper>
              </Modal.Body>
            </Modal>
            <FinancialTargets
              round={activeRound}
              financialTargets={financialTargets}
              showTableOnly={true}
              onHelpIconClick={this.onHelpIconClick}
            />
          </div>
        )}
      />
    ) : <Loader type="ball-scale-ripple" active />;
  }

}

export default ResultsAreInStep6;



// WEBPACK FOOTER //
// ./src/components/performance-feedback/pages/results-are-in/step6.js